/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManageUserProfile } from '../../models/manage-user-profile';

export interface ApiRoleOptUserStartwithGet$Params {
  startWith?: string;
  max?: number;
}

export function apiRoleOptUserStartwithGet(http: HttpClient, rootUrl: string, params?: ApiRoleOptUserStartwithGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManageUserProfile>>> {
  const rb = new RequestBuilder(rootUrl, apiRoleOptUserStartwithGet.PATH, 'get');
  if (params) {
    rb.query('startWith', params.startWith, {});
    rb.query('max', params.max, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ManageUserProfile>>;
    })
  );
}

apiRoleOptUserStartwithGet.PATH = '/api/role/opt/user/startwith';
